import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';

export type TimelineActivity = {
    title: string;
    description?: string | null;
    created_at?: string | null;
    created_by_name?: string | null;
    metadata?: Record<string, unknown> | null;
};

type TimelineState = 'completed' | 'current' | 'future';

@Component({
    selector: 'app-activity-timeline',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './activity-timeline.component.html',
    styleUrl: './activity-timeline.component.css',
})
export class ActivityTimelineComponent {
    @Input() activities: TimelineActivity[] = [];
    @Input() currentIndex = -1;

    get displayActivities(): TimelineActivity[] {
        return [...(this.activities || [])].reverse();
    }

    getState(index: number): TimelineState {
        const items = this.displayActivities;
        if (!items.length) {
            return 'future';
        }

        if (this.currentIndex >= 0) {
            if (index < this.currentIndex) {
                return 'completed';
            }
            if (index === this.currentIndex) {
                return 'current';
            }
            return 'future';
        }

        if (index === items.length - 1) {
            return 'current';
        }
        return 'completed';
    }

    isLast(index: number): boolean {
        return index === this.displayActivities.length - 1;
    }
}
